import React from 'react';
import { Family } from '../../types';

interface HomeLocationSectionProps {
  family: Family;
  onUpdate: (updates: Partial<Family>) => void;
}

export const HomeLocationSection: React.FC<HomeLocationSectionProps> = ({
  family,
  onUpdate,
}) => {
  return (
    <section className="family-section">
      <h2>Home Location</h2>
      <p className="section-why">
        I'll use this for weather forecasts and travel estimates.
      </p>
      <div className="detail-row" style={{ display: 'flex', gap: '0.5rem' }}>
        <input
          type="text"
          value={family.home_city || ''}
          onChange={(e) => onUpdate({ home_city: e.target.value })}
          placeholder="City"
          className="detail-input"
          style={{ flex: 1 }}
        />
        <input
          type="text"
          value={family.home_state || ''}
          onChange={(e) => onUpdate({ home_state: e.target.value })}
          placeholder="State"
          className="detail-input"
          style={{ maxWidth: '80px' }}
        />
      </div>
    </section>
  );
};

export default HomeLocationSection;
